export const photos = [
  {
    src: '/photos/gallery/album/63B2CCCD-F198-4747-B1BE-914899E4B347.png',
    width: 4,
    height: 5,
  },
  {
    src: '/photos/gallery/album/98828A28-0B81-4C29-B728-D06195FC3088.png',
    width: 1,
    height: 1,
  },
  {
    src: '/photos/gallery/album/B3A7DBA6-F08B-492D-B832-0364DDCD8042.png',
    width: 3,
    height: 4,
  },
  {
    src: '/photos/gallery/album/DSC_0875.JPG',
    width: 3,
    height: 4,
  },
  {
    src: '/photos/gallery/album/DSC_0876.JPG',
    width: 3,
    height: 4,
  },
  {
    src: '/photos/gallery/album/IMG_2709.JPG',
    width: 4,
    height: 3,
  },
  {
    src: '/photos/gallery/album/IMG_2714.JPG',
    width: 3,
    height: 4,
  },
  {
    src: '/photos/gallery/album/IMG_2724.JPG',
    width: 4,
    height: 3,
  },
  {
    src: '/photos/gallery/album/IMG_2755.JPG',
    width: 4,
    height: 3,
  },
  {
    src: '/photos/gallery/album/IMG_2742.JPG',
    width: 4,
    height: 3,
  },
  {
    src: '/photos/gallery/album/IMG-20231103-WA0015.jpg',
    width: 4,
    height: 3,
  },
  {
    src: '/photos/gallery/album/IMG_2740.JPG',
    width: 1,
    height: 1,
  },
  {
    src: '/photos/gallery/album/IMG_2741.JPG',
    width: 1,
    height: 1,
  },
  {
    src:'/photos/gallery/album/web_dev_bootcamp1.jpg',
    width: 1,
    height: 1,
  },
  {
    src: '/photos/gallery/album/web_dev_bootcamp2.jpg',
    width: 1,
    height: 1,
  },
  {
    src: '/photos/gallery/album/web_dev_bootcamp3.jpg',
    width: 1,
    height: 1,
  },
  {
    src: '/photos/gallery/album/snap_circuit1.jpg',
    width: 1,
    height: 1,
  },
  {
    src: '/photos/gallery/album/DSC_0942.JPG',
    width: 1,
    height: 1,
  },
  {
    src: '/photos/gallery/album/20231125_223933.jpg',
    width: 1,
    height: 1,
  },
  {
    src: '/photos/gallery/album/IMG_20221126_162112.jpg',
    width: 1,
    height: 1,
  },
  {
    src: '/photos/gallery/album/IMG_20221126_171253.jpg',
    width: 1,
    height: 1,
  },
  {
    src: '/photos/gallery/album/IMG_2024.jpg',
    width: 1,
    height: 1,
  },
  {
    src: '/photos/gallery/album/snap_circuit2.jpg',
    width: 1,
    height: 1,
  },
  
]
